export default __webpack_public_path__ + "static/media/when-we-all-fall-asleep-where-do-we-go.ffab625d.png";